/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ListGroup, ListGroupItem, Table } from "reactstrap";
import SweetAlert from "sweetalert2";
import { toast } from "react-toastify";

import { BlurSpinner } from "../../components/BlurSpinner";
import { handleErrors } from "../../services/handleErrors";
import { patchFolder } from "../../services/fileManagerService";
import { removeFile, downloadFile } from "../../services/fileServices";
import ShareFolder from "./shareFolder";
import FileItem from "./fileItem";
// import ShareFolder from "./shareFolder";

const FileList = ({ files, handleDoubleClick, refreshFolders }) => {
  const fileListFiltered = [...files];
  const [modalMoveFolder, setModalMoveFolder] = useState(false);
  const [modalShareFolder, setModalShareFolder] = useState(false);
  const [folderListToMove, setFolderListToMove] = useState([]);
  const [folderSelectedToMove, setFolderSelectedToMove] = useState({});
  const [isDownloadingFile, setIsDownloadingFile] = useState(false);
  const [shareFolderSelected, setShareFolderSelected] = useState();

  const toggleMoveFolder = () => {
    setModalMoveFolder(!modalMoveFolder);
  };

  const toggleShareFolder = () => {
    setModalShareFolder(!modalShareFolder);
  };

  const handleDeleteFile = async (file) => {
    const { isConfirmed } = await SweetAlert.fire({
      title: `Borrar ${file.name}`,
      text: "¿Seguro que desea borrar el archivo?",
      icon: "warning",
      showCancelButton: true,
      showConfirmButton: true,
    });

    if (isConfirmed) {
      await removeFile({ entity: "folder", entityId: file.parentId, fileId: file.realId });
      refreshFolders();
      toast.success(`Archivo ${file.name} borrado exitosamente`);
    }
  };

  const handleDownloadFile = async (file) => {
    setIsDownloadingFile(true);
    try {
      await downloadFile({ entity: "folder", entityId: file.parentId, fileId: file.realId });
      toast.success(`Archivo ${file.name} descargado exitosamente`);
    } catch (err) {
      handleErrors(err, toast.error);
    } finally {
      setIsDownloadingFile(false);
    }
  };

  const handleChangeFolderName = async (folder) => {
    const { value: rename } = await SweetAlert.fire({
      title: "Ingrese nuevo nombre",
      input: "text",
      confirmButtonColor: "#bf0d3e",
      inputAttributes: {
        maxlength: 60,
        autocapitalize: "off",
        autocorrect: "off",
      },
    });

    if (rename) {
      try {
        const folderData = {
          name: rename,
          isProtected: folder.isProtected,
        };
        await patchFolder({ entityId: folder.id, folderData });
        toast.success(`Carpeta actualizada exitosamente`);
      } catch (err) {
        handleErrors(err, toast.error);
      } finally {
        refreshFolders();
      }
    }
  };

  const handleMoveFolderTo = (folderSelected) => {
    setFolderSelectedToMove(folderSelected);
    const filesCopy = [...files];
    const listFolderCanMove = filesCopy.filter((item) => item.isFolder && item.id !== folderSelected.id);
    setFolderListToMove(listFolderCanMove);
    setModalMoveFolder(true);
  };

  const actionMoveFolderTo = async (destinationFolder) => {
    if (folderSelectedToMove.id && destinationFolder.id) {
      try {
        const folderData = {
          name: folderSelectedToMove.name,
          isProtected: folderSelectedToMove.isProtected,
          parentId: destinationFolder.id,
        };
        await patchFolder({ entityId: folderSelectedToMove.id, folderData });
        toast.success(`Carpeta actualizada exitosamente`);
      } catch (err) {
        handleErrors(err, toast.error);
      } finally {
        setModalMoveFolder(false);
        refreshFolders();
      }
    }
  };

  const handleShareFolder = (folderItem) => {
    if (folderItem.id) {
      setShareFolderSelected(folderItem);
      toggleShareFolder();
    }
  };

  return (
    <>
      {fileListFiltered ? (
        <BlurSpinner isLoading={isDownloadingFile}>
          <Table>
            <thead>
              <tr>
                <th aria-label="Select" />
                <th> Nombre </th>
                <th> Última modificación </th>
                <th aria-label="Select" />
              </tr>
            </thead>
            <tbody>
              {fileListFiltered.map((file) => (
                <FileItem
                  key={file.id}
                  file={file}
                  handleDeleteFile={handleDeleteFile}
                  handleDoubleClick={handleDoubleClick}
                  handleChangeFolderName={handleChangeFolderName}
                  handleMoveFolderTo={handleMoveFolderTo}
                  handleDownloadFile={handleDownloadFile}
                  handleShareFolder={handleShareFolder}
                />
              ))}
            </tbody>
          </Table>
        </BlurSpinner>
      ) : (
        <h6> Carpeta vacia </h6>
      )}
      <Modal isOpen={modalMoveFolder} toggle={toggleMoveFolder}>
        <ModalHeader toggle={toggleMoveFolder}> Mover carpeta a </ModalHeader>
        <ModalBody>
          {folderListToMove && (
            <ListGroup>
              {folderListToMove.map((folder) => (
                <ListGroupItem key={folder.id} className="list-group-item-action" tag="a" color="light" onClick={() => actionMoveFolderTo(folder)}>
                  <i className="icon-save-alt" /> {folder.name}
                </ListGroupItem>
              ))}
            </ListGroup>
          )}
        </ModalBody>
      </Modal>
      <Modal centered backdrop="static" isOpen={modalShareFolder} toggle={toggleShareFolder}>
        <ModalHeader toggle={toggleShareFolder}> Compartir con personas </ModalHeader>
        <ModalBody>
          <ShareFolder selected={shareFolderSelected} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default FileList;
